import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UsersTransactionsStatistic } from '../users-transactions-statistic.model';

@JsonObject('UsersTransactionsStatisticsResultsResponse')
export class UsersTransactionsStatisticsResultsResponse extends ApiResultsResponse<UsersTransactionsStatistic> {

  @JsonProperty('results', [UsersTransactionsStatistic])
  override results: UsersTransactionsStatistic[] = [];
}
